import { memo } from "react";
import "./skeleton.css";

const SkeletonComponent = ({ ...restProps }) => {
  return (
    <span className="skeleton-container" {...restProps}>
      &nbsp;
    </span>
  );
};

export const Skeleton = memo(SkeletonComponent);
